var _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCloudRightDesktop(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 297,
    height: 182,
    viewBox: "0 0 297 182",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M246.977 91.5176C246.977 91.4253 246.981 91.334 246.981 91.2417C246.981 41.1898 206.714 0.614746 157.042 0.614746C120.214 0.614746 88.5605 22.9242 74.6523 54.8598C71.1243 54.2477 67.4989 53.9249 63.7979 53.9249C28.7358 53.9249 0.312012 82.5663 0.312012 117.897C0.312012 153.227 28.7358 181.869 63.7979 181.869H251.941C276.776 181.869 296.909 161.581 296.909 136.555C296.909 111.529 276.776 91.2417 251.941 91.2417C250.263 91.2417 248.607 91.3373 246.977 91.5176Z",
    fill: "url(#paint0_linear_166_5833)",
    fillOpacity: 0.8
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_166_5833",
    x1: 148.611,
    y1: 124.88,
    x2: 137.866,
    y2: 47.0398,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloudRightDesktop);
export default __webpack_public_path__ + "static/media/cloud-right-desktop.364973289a50e4d2c848a3dda1f2af98.svg";
export { ForwardRef as ReactComponent };